import React, { useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollCar from './components/ScrollCar';
import Home from './pages/Home';
import Features from './pages/Features';
import LoginPage from './pages/LoginPage';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import About from './pages/About';
import FAQ from './pages/FAQ';
import NotFound from './pages/NotFound';
import NetworkEngine, { type NetworkEngineRef } from './components/NetworkEngine';
import { NetworkEngineContext } from './components/NetworkEngineContext';
import './App.css';

/* Layout wrapper — ScrollCar only on Home */
const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <>
      {/* ScrollCar — only on home page */}
      {isHome && <ScrollCar />}

      {/* App layout — z-10 sits above canvas */}
      <div className="relative z-10 flex flex-col min-h-screen overflow-x-hidden">
        <Header />
        <main className="flex-grow">{children}</main>
        <Footer />
      </div>
    </>
  );
};

const App: React.FC = () => {
  const engineRef = useRef<NetworkEngineRef>(null);

  return (
    <Router>
      <NetworkEngineContext.Provider value={engineRef}>
        {/* Persistent canvas background — never unmounts */}
        <NetworkEngine ref={engineRef} />

        <AppLayout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<Features />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AppLayout>
      </NetworkEngineContext.Provider>
    </Router>
  );
};

export default App;
